module.exports = __webpack_public_path__ + "img/kamyonet-kasali.9c56f2d0.svg";